var Backbone = require('backbone'),
    Raphael = require('raphael');

module.exports = Backbone.Model.extend({
    minDimension: 5, //the smallest a shape can be in order to be created  (pixels)   -- for rect -- either vertical / horizontal
    minDrawTime: 100, //threshold for how long to allow mousedown to mouseup in drawing shap
    defaults: {
        xy: {x: 0, y: 0},
        oxy: {x: 0, y: 0},
        dxy: {x: 0, y: 0},
        odxy: {x: 0, y: 0},
        start: null
    },
    initialize: function(options) {
        this.set({
            xy: options.xy,
            oxy: options.xy,
            start: new Date().getTime()
        });
        return this;
    },
    update: function(xy) {
        this.set({
            xy: xy,
            dxy: {
                x: xy.x - this.previous('xy').x,
                y: xy.y - this.previous('xy').y
            },
            odxy: {
                x: xy.x - this.get('oxy').x,
                y: xy.y - this.get('oxy').y
            }
        });
        return this; //allow changing
    },
    isTooShortOrSmall: function( pathStr ) {
        var stop = new Date().getTime(), //make the time of the stop
            isRect = !pathStr ,  //use diff method for rect (non total path len)
            tooShort = Math.abs(this.get('start') - stop) < this.minDrawTime,
            tooSmall = isRect ?  Math.abs(this.get('odxy').x) <= this.minDimension || Math.abs(this.get('odxy').y) <= this.minDimension
                              :  Raphael.getTotalLength( pathStr ) <= this.minDimension;
        return (tooShort || tooSmall);
    },
    noChangeInOriginalPosition: function() {
        return this.get('odxy').x === 0 && this.get('odxy').y === 0;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/helper/mouseTracker.js
 ** module id = 361
 ** module chunks = 0
 **/